import React, { useState } from "react";
import {
	Box,
	Typography,
	TextField,
	Button,
	Checkbox,
	FormControlLabel,
	Link,
	Alert,
	IconButton,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import config from "../config.json";
import { useUser } from "../contexts/UserContext";

const LoginForm = () => {
	const navigate = useNavigate();
	const { setUserRole, setUserId, setUserCustomerId } = useUser();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [showPassword, setShowPassword] = useState(false);

	const handleSignIn = async (e) => {
		e.preventDefault();

		try {
			const response = await fetch(`${config.baseURL}middlewareUsers`, {
				method: "GET",
				headers: {
					...config.headers,
				},
			});

			console.log("Response status:", response);

			if (response.ok) {
				const users = await response.json();
				console.log("Fetched users:", users);

				const user = users.find(
					(user) => user.email === email && user.password_hash === password
				);
				console.log("Found user:", user);

				if (user) {
					console.log("user.customer_id:", user.customer_id);
					setUserId(user.id);
					setUserRole(user.role);
					setUserCustomerId(user.customer_id);

					if (user.role === "admin") {
						navigate("/customer-management");
					} else if (user.role === "user") {
						navigate("/dashboard");
					}
				} else {
					setError("Invalid email or password. Please try again.");
				}
			} else {
				const errorData = await response.json();
				setError(`Server error: ${errorData.message || "Unable to login."}`);
			}
		} catch (err) {
			console.error("Network Error:", err);
			setError("Something went wrong. Please check your connection.");
		}
	};

	const handleSignupClick = (e) => {
		e.preventDefault();
		navigate("/signup");
	};

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	return (
		<Box
			sx={{
				maxWidth: 400,
				mx: "auto",
				mt: 8,
				p: 3,
				boxShadow: 3,
				borderRadius: 2,
				position: "relative",
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					mb: 2,
				}}
			>
				<Box
					component="img"
					src="https://res.cloudinary.com/dzu2lu2i4/image/upload/v1733212285/66b716b61e317999158e6fb8_LOGO_140_x30_1_ocp65j.png"
					alt="Company Logo"
					sx={{
						height: 30,
						width: "auto",
					}}
				/>
			</Box>

			<Typography
				variant="h4"
				component="h1"
				gutterBottom
				sx={{ textAlign: "center" }}
			>
				Welcome back
			</Typography>
			<Typography
				variant="body1"
				color="textSecondary"
				gutterBottom
				sx={{ textAlign: "center" }}
			>
				Enter your credentials to access your account
			</Typography>

			{error && (
				<Alert severity="error" sx={{ mb: 2 }}>
					{error}
				</Alert>
			)}

			<Box component="form" sx={{ mt: 2 }} onSubmit={handleSignIn}>
				<TextField
					label="Email"
					name="email"
					type="email"
					placeholder="name@example.com"
					autoComplete="email"
					fullWidth
					margin="normal"
					InputProps={{
						startAdornment: <EmailOutlinedIcon sx={{ mr: 1 }} />,
					}}
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					required
				/>
				<TextField
					label="Password"
					name="password"
					type={showPassword ? "text" : "password"}
					placeholder="Enter your password"
					autoComplete="current-password"
					fullWidth
					margin="normal"
					InputProps={{
						startAdornment: <LockOutlinedIcon sx={{ mr: 1 }} />,
						endAdornment: (
							<IconButton
								aria-label="toggle password visibility"
								onClick={togglePasswordVisibility}
								edge="end"
							>
								{showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
							</IconButton>
						),
					}}
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					required
				/>
				<FormControlLabel
					control={<Checkbox />}
					label="Remember me"
					sx={{ textAlign: "left", display: "block", mt: 1 }}
				/>
				<Link
					href="#"
					underline="hover"
					sx={{ display: "block", textAlign: "right", mb: 2 }}
				>
					Forgot password?
				</Link>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					sx={{
						backgroundColor: "#000",
						"&:hover": { backgroundColor: "#333" },
					}}
				>
					SIGN IN
				</Button>
				<Typography sx={{ mt: 3, textAlign: "center" }}>
					Don&apos;t have an account?
				</Typography>
				<Link
					href="#"
					underline="hover"
					onClick={handleSignupClick}
					sx={{
						mt: 1,
						display: "block",
						textAlign: "center",
						cursor: "pointer",
					}}
				>
					Create account
				</Link>
			</Box>
		</Box>
	);
};

export default LoginForm;
